export const DOCUMENT_STATUS = Object.freeze({
  FALSE: 0,
  TRUE: 1
})
